module.exports = __webpack_public_path__ + "assets/img/userDetailIcon.2b90910e.svg";